import { Image } from "theme-ui";
import WriteFromDictationDataFrom0To100 from "../../../../doc/listening/write-from-dictation/WriteFromDictationDataFrom0To100";
import WriteFromDictationList from "../../../../doc/components/WriteFromDictationList.js";
import * as React from 'react';
export default {
  Image,
  WriteFromDictationDataFrom0To100,
  WriteFromDictationList,
  React
};